import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { getDownloadURL, listAll, ref, Storage } from '@angular/fire/storage';
import { ModalController } from "@ionic/angular";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Finishing, PageSize, PaperWeight, Settings } from 'src/app/shared-lib/core/settings';
import { AppService } from "../../shared/app.service";
import { FileService } from "../../shared/file.service";
import { VideoPlayerModalComponent } from "../video-player-modal/video-player-modal.component";

@Component({
  selector: 'app-cover-settings',
  templateUrl: './cover-settings.component.html',
  styleUrls: ['./cover-settings.component.scss'],
  standalone: false
})
export class CoverSettingsComponent implements OnInit {
  @Input() fileSettings;
  @Input() currentCoverType;
  paperWeight = PaperWeight.W80;
  coverOption = null;
  coverSettings = null;
  videoPath = `videos/cover-types`;
  videoList$: Observable<string[]>;
  @ViewChild('videoModal', { static: true }) videoModal!: TemplateRef<any>;

  paperOptions = [];

  subtitles = {
    'Color1Side1Page-Black1Side1Page': 'La primera cara de tu documento irá a color. El resto de tu documento irá en blanco y negro.',
    'Black1Side1Page-Black1Side1Page': 'Todo tu documento irá en blanco y negro.',
    'Color1Side1Page-Black1Side2Page': 'La primera cara de tu documento irá a color a 1 página por cara.  El resto de tu documento irá en blanco y negro a 2 páginas por cara.',
    'Black1Side1Page-Black1Side2Page': 'La primera cara de tu documento irá en blanco y negro a 1 página por cara. El resto de tu documento irá en blanco y negro a 2 páginas por cara.',
    'Black1Side2Page-Black1Side2Page': 'Todo tu documento irá en blanco y negro a 2 páginas por cara. ',
    'Color1Side1Page-Black1Side4Page': 'La primera cara de tu documento irá a color a 1 página por cara. El resto de tu documento irá en blanco y negro a 4 páginas por cara.',
    'Black1Side1Page-Black1Side4Page': 'La primera cara de tu documento irá en blanco y negro a 1 página por cara. El resto de tu documento irá en blanco y negro a 4 páginas por cara.',
    'Black1Side4Page-Black1Side4Page': 'Todo tu documento irá en blanco y negro a 4 páginas por cara. ',
    'Color2Side1Page-Black2Side1Page': 'La primera y segunda cara de tu documento irán a color. El resto de tu documento irá en blanco y negro a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Black2Side1Page': 'La primera cara de tu documento irá a color. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a doble cara (por delante y por detrás del folio).',
    'Black1Side1Page-Black2Side1Page': 'La primera cara de tu documento irá en blanco y negro. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a doble cara (por delante y por detrás del folio).',
    'Black2Side1Page-Black2Side1Page': 'Todo tu documento irá en blanco y negro, a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Black2Side2Page': 'La primera cara de tu documento irá a 1 página por cara, a color. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a 2 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Black1Side1Page-Black2Side2Page': 'La primera cara de tu documento irá a 1 página por cara en blanco y negro. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a 2 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Black2Side2Page-Black2Side2Page': 'Todo tu documento irá en blanco y negro, 2 páginas por cara, a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Black2Side4Page': 'La primera cara de tu documento irá a 1 página por cara a color. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a 4 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Black1Side1Page-Black2Side4Page': 'La primera cara de tu documento irá a 1 página por cara en blanco y negro. La segunda cara estará en blanco. El resto de tu documento irá en blanco y negro a 4 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Black2Side4Page-Black2Side4Page': 'Todo tu documento irá en blanco y negro, 4 páginas por cara, a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Color1Side1Page': 'Todo tu documento irá a color.',
    'Color1Side1Page-Color1Side2Page': 'La primera cara de tu documento irá a color a 1 página por cara. El resto de tu documento irá a color a 2 páginas por cara.',
    'Color1Side2Page-Color1Side2Page': 'Todo tu documento irá a color a 2 páginas por cara. ',
    'Color1Side1Page-Color1Side4Page': 'La primera cara de tu documento irá a color a 1 página por cara. El resto de tu documento irá a color a 4 páginas por cara.',
    'Color1Side4Page-Color1Side4Page': 'Todo tu documento irá a color a 4 páginas por cara. ',
    'Color2Side1Page-Color2Side1Page': 'Todo tu documento irá a color y a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Color2Side1Page': 'La primera cara de tu documento irá a color. La segunda cara estará en blanco.  El resto de tu documento irá a color y a doble cara (por delante y por detrás del folio).',
    'Color2Side2Page-Color2Side2Page': 'Todo tu documento irá a color a 2 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Color2Side2Page': 'La primera cara de tu documento irá a 1 página por cara a color. La segunda cara estará en blanco. El resto de tu documento irá a color a 2 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Color2Side4Page-Color2Side4Page': 'Todo tu documento irá a color a 4 páginas por cara y a doble cara (por delante y por detrás del folio).',
    'Color1Side1Page-Color2Side4Page': 'La primera cara de tu documento irá a 1 página por cara a color. La segunda cara estará en blanco.  El resto de tu documento irá a color a 4 páginas por cara y a doble cara (por delante y por detrás del folio).',
  };

  constructor(private appService: AppService, public modalController: ModalController, public fileService: FileService, private storage: Storage) {
  }

  ngOnInit() {
    this.initPaperOptions();
    this.videoList$ = this.getVideoList();
    this.paperWeight = this.currentCoverType.paperWeight;
    this.coverSettings = this.fileService.getCoverSettings();
    this.coverSettings = this.coverSettings.filter(setting => {
      return setting.requirements.some(requirements =>
        Object.keys(requirements).every(key =>
          this.fileSettings.hasOwnProperty(key) && this.fileSettings[key] === requirements[key]
        )
      );
    });
    if (this.fileSettings.coverLaminated) {
      this.coverSettings = this.coverSettings.filter(cs => cs.value.coverColor);
    }
    this.coverOption = this.currentCoverType;
  }

  isDisabled(option: any): boolean {
    return !this.checkAvailability(option);
  }

  private checkAvailability(option: any): boolean {
    const getSelectedIndex = (settingName: string, value: any) => {
      return this.appService.getSelectedIndexForOption(settingName as Settings, { value });
    };
    const unavailableFor = option.unavailableFor || [];
    const isUnavailable = unavailableFor.some(unavailable => {
      let value = this.fileSettings[unavailable.id];
      if (unavailable.id === 'twoSided' && this.coverOption && this.coverOption.hasOwnProperty('twoSided')) {
        value = this.coverOption.twoSided;
      }
      const selectedIndex = getSelectedIndex(unavailable.id, value);
      return unavailable.options.includes(selectedIndex);
    });

    const unavailableForGrouped = option.unavailableForGrouped || [];
    const isUnavailableGrouped = unavailableForGrouped.some(group =>
      group.properties.every(unavailable => {
        let value = this.fileSettings[unavailable.id];
        if (unavailable.id === 'twoSided' && this.coverOption && this.coverOption.hasOwnProperty('twoSided')) {
          value = this.coverOption.twoSided;
        }
        const selectedIndex = getSelectedIndex(unavailable.id, value);
        return unavailable.options.includes(selectedIndex);
      })
    );

    return !isUnavailable && !isUnavailableGrouped;
  }

  getTooltip(option: any): string | null {
    const getSelectedIndex = (settingName: string, value: any) => {
      return this.appService.getSelectedIndexForOption(settingName as Settings, { value });
    };

    const unavailableFor = option.unavailableFor || [];
    const unavailableRule = unavailableFor.find(unavailable => {
      let value = this.fileSettings[unavailable.id];
      if (unavailable.id === 'twoSided' && this.coverOption && this.coverOption.hasOwnProperty('twoSided')) {
        value = this.coverOption.twoSided;
      }
      const selectedIndex = getSelectedIndex(unavailable.id, value);
      return unavailable.options.includes(selectedIndex);
    });

    if (unavailableRule) {
      return unavailableRule.disabledTooltip ?? null;
    }

    const unavailableForGrouped = option.unavailableForGrouped || [];
    const unavailableGroupedRule = unavailableForGrouped.find(group =>
      group.properties.every(unavailable => {
        let value = this.fileSettings[unavailable.id];
        if (unavailable.id === 'twoSided' && this.coverOption && this.coverOption.hasOwnProperty('twoSided')) {
          value = this.coverOption.twoSided;
        }
        const selectedIndex = getSelectedIndex(unavailable.id, value);
        return unavailable.options.includes(selectedIndex);
      })
    );

    if (unavailableGroupedRule) {
      return unavailableGroupedRule.disabledTooltip ?? null;
    }

    return null;
  }

  saveCoverType() {
    const coverType = { ...this.coverOption, paperWeight: this.paperWeight };
    if (this.fileService.getDefaultCoverType(this.fileSettings, this.fileSettings).id === this.coverOption.id) {
      coverType.default = true;
    } else {
      delete coverType.default;
    }

    if (this.paperWeight !== this.currentCoverType.paperWeight) {
      coverType.paperWeightChanged = this.paperWeight;
    }
    this.modalController.dismiss({ coverType });
  }

  // TODO: To helper (dont know which one)
  getCoverTypeFullId(coverType) {
    return coverType.id + '-' +
      (this.fileSettings.docColor ? 'Color' : 'Black') +
      (this.fileSettings.twoSided ? '2' : '1') + 'Side' +
      this.fileSettings.pagesPerSheet + 'Page';
  }

  protected readonly PaperWeight = PaperWeight;

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }

  getVideoList(): Observable<string[]> {
    const storageRef = ref(this.storage, this.videoPath);
    return from(listAll(storageRef)).pipe(
      map((result) => result.items.map((item) => item.name))
    );
  }

  protected readonly Finishing = Finishing;

  videoExists(videoList, coverType) {
    return false;
    return videoList.includes(this.getCoverTypeFullId(coverType) + '.mp4');
  }

  async showVideo(event, coverType) {
    event.stopPropagation();

    const storageRef = ref(this.storage, `videos/cover-types/${this.getCoverTypeFullId(coverType) + '.mp4'}`);
    const videoUrl = await getDownloadURL(storageRef);

    const modal = await this.modalController.create({
      component: VideoPlayerModalComponent,
      cssClass: 'auto-height',
      componentProps: {
        videoUrl: videoUrl,
      }
    });

    await modal.present();
  }

  protected readonly Number = Number;
  protected readonly PageSize = PageSize;

  private initPaperOptions() {
    const defaultOptions = this.appService.getPrintSettings().paperWeight.options;

    // TODO: To helper (dont know which one)
    const createOption = (weight: PaperWeight, title: string, subtitle: string, hideCondition: boolean) => {
      const masterOpt = defaultOptions.find(opt => opt.value === weight);
      return {
        value: weight,
        title,
        subtitle,
        hideCondition,
        unavailableFor: masterOpt?.unavailableFor,
        unavailableForGrouped: masterOpt?.unavailableForGrouped
      };
    };
    this.paperOptions = [
      createOption(PaperWeight.W80, '80 gr', 'Un folio de toda la vida', this.fileSettings.paperWeight === PaperWeight.W80),
      createOption(PaperWeight.W90, '90 gr', 'Un poco más grueso', Number(this.fileSettings.paperWeight) <= 90 && (this.fileSettings.finishing !== Finishing.STAPLED || this.fileSettings.paperWeight === PaperWeight.W90)),
      createOption(PaperWeight.W100, '100 gr', 'Un poco más grueso aún', Number(this.fileSettings.paperWeight) <= 100 && (this.fileSettings.finishing !== Finishing.STAPLED || this.fileSettings.paperWeight === PaperWeight.W100)),
      createOption(PaperWeight.W120, '120 gr', 'Aún más grueso', Number(this.fileSettings.paperWeight) <= 120 && this.fileSettings.pageSize !== PageSize.A3 && (![Finishing.LAMINATED, Finishing.STAPLED].includes(this.fileSettings.finishing) || this.fileSettings.paperWeight === PaperWeight.W120)),
      createOption(PaperWeight.W160, '160 gr', 'Ni fino ni grueso', Number(this.fileSettings.paperWeight) <= 160 && (![Finishing.LAMINATED, Finishing.STAPLED].includes(this.fileSettings.finishing) || this.fileSettings.paperWeight === PaperWeight.W160)),
      createOption(PaperWeight.W200, '200 gr', 'Tipo cartulina fina', Number(this.fileSettings.paperWeight) <= 200 && this.fileSettings.pageSize === PageSize.A3 && (![Finishing.LAMINATED, Finishing.STAPLED].includes(this.fileSettings.finishing) || this.fileSettings.paperWeight === PaperWeight.W200)),
      createOption(PaperWeight.W300, '300 gr', 'Tipo cartulina del cole', ![Finishing.LAMINATED, Finishing.STAPLED].includes(this.fileSettings.finishing))
    ];
  }
}
